import React from "react";
import { Card, Alert } from "react-bootstrap";

function Dashboard() {
  return (
    <div>
      <h2 className="mb-4">Dashboard Overview</h2>

      <Alert variant="info">
        Your Dashboard is your home base for monitoring runbook activity and accessing your favorite runbooks.
      </Alert>

      <Card className="mb-4">
        <Card.Body>
          <h4>Dashboard Widgets</h4>
          <p>The Dashboard displays several widgets that provide quick access to important information:</p>

          <h5 className="mt-4">Favorite Runbooks</h5>
          <p>
            Shows runbooks you've marked as favorites. Click on any runbook to view its details or execute it.
            To mark a runbook as a favorite, go to My Runbooks and click the star icon next to the runbook name.
          </p>

          <h5 className="mt-4">Latest Executions</h5>
          <p>
            Displays the 10 most recent runbook executions with their status. This widget automatically refreshes
            every 5 minutes to show you the latest activity. Click on any execution to view detailed results.
          </p>

          <h5 className="mt-4">Next Executions</h5>
          <p>
            Shows upcoming scheduled runbook executions. This helps you see what automated tasks are scheduled to run next.
          </p>

          <h5 className="mt-4">KPIs (Key Performance Indicators)</h5>
          <p>
            Displays performance metrics and statistics about your runbook usage.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Customizing Your Dashboard</h4>
          <p>
            You can customize your dashboard layout by dragging and dropping widgets to reorder them according to your preferences.
          </p>
        </Card.Body>
      </Card>

      <Card className="mb-4">
        <Card.Body>
          <h4>Execution Status Icons</h4>
          <p>When viewing executions, you'll see different status indicators:</p>
          <ul>
            <li><strong>Not Started</strong> - Execution has been queued but not yet started</li>
            <li><strong>In Process</strong> - Execution is currently running</li>
            <li><strong>Completed</strong> - Execution finished successfully</li>
            <li><strong>Error</strong> - Execution failed with an error</li>
            <li><strong>Authentication Failed</strong> - Could not authenticate with external system</li>
            <li><strong>Completed with Errors</strong> - Execution finished but some steps had issues</li>
            <li><strong>Runbook Timeout</strong> - Execution exceeded maximum time limit</li>
          </ul>
        </Card.Body>
      </Card>
    </div>
  );
}

export default Dashboard;
